import React, { useEffect, useRef } from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import productImagePath from "../../../helpers/product-image-path";
import Routes from "routes";

// This component is shared across both the current and universal PDP
export default function ProductDetails(props) {
  const elementRef = useRef();

  const getShareUrl = () => {
    const shareUrl = new URL(Routes.PDP.RouteById(props.productId), "https://www.renttherunway.com");
    return encodeURIComponent(shareUrl);
  };

  const getPinterestUrl = () => {
    const { images: productImages, imageRotation, designerDisplayName, displayName } = props;
    const images = _.chain(_.pick(productImages, imageRotation)).values().first().value(),
      productImage = images?.["1080x"];

    return (
      "https://www.pinterest.com/pin/create/button/?url=" +
      getShareUrl() +
      "&media=" +
      encodeURIComponent(productImagePath + productImage) +
      "&description=" +
      encodeURIComponent(designerDisplayName + " " + displayName)
    );
  };

  useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse(elementRef.current);
    }
  });

  const renderDetailContent = (sectionContent, sectionTitle) => {
    return (
      <>
        {!!sectionTitle && <h3 className="universal-small--semibold">{sectionTitle}</h3>}
        {!!sectionContent && <div className="universal-small" dangerouslySetInnerHTML={{ __html: sectionContent }} />}
      </>
    );
  };

  const optionalContent = () => {
    const { showOptionalDetails } = props;

    if (!showOptionalDetails) {
      return [];
    }

    return (
      <div className="section">
        <h3 className="universal-small--semibold product-details-sub-heading">Shop with confidence</h3>
        <div className="product-details__buy-now-messaging universal-small json-markup">
          <ul>
            <li>Return accepted within 7 days, restocking fee applies</li>
            <li>Highest quality and cleanliness standards</li>
            <li>Authenticity guaranteed</li>
          </ul>
        </div>
      </div>
    );
  };

  const renderShare = () => {
    const { fitNotes } = props;

    return (
      <div className="section">
        <h3 className={`${fitNotes ? "product-details-sub-heading" : ""} universal-small--semibold`}>Share</h3>

        <div className="social-link">
          <div className="fb-share-button-container log" data-action="click_productshare_facebook">
            <div
              className="fb-share-button"
              data-action="share"
              data-href={getShareUrl()}
              data-layout="button"
              data-share="true"></div>
          </div>
          <div className="facebook-share-icon" />
        </div>

        <div className="social-link pinterest-button log" data-action="click_productshare_pinterest">
          <a data-pin-do="buttonPin" aria-label="Pinterest Share" href={getPinterestUrl()}>
            <div className="pinterest-share-icon" />
          </a>
        </div>
      </div>
    );
  };

  return (
    <div id="product-details" data-test-id="product-details" ref={elementRef}>
      <div className="product-details">
        {!props.isMobileViewport && <h2 className="product-details-heading h3">Product Details</h2>}
        <div className="first-section">{props.stylistNotes && renderDetailContent(props.stylistNotes)}</div>
        <div className="second-section section">
          {props.productDetails && renderDetailContent(props.productDetails, "Materials and Measurements")}
          {optionalContent()}
        </div>
        <div className="third-section section">
          {props.fitNotes && renderDetailContent(props.fitNotes, "Size and Fit")}
          {renderShare()}
        </div>
      </div>
    </div>
  );
}

ProductDetails.propTypes = {
  images: PropTypes.object,
  showOptionalDetails: PropTypes.bool,
  imageRotation: PropTypes.arrayOf(PropTypes.object),
  isMobileViewport: PropTypes.bool,
  displayName: PropTypes.string,
  designerDisplayName: PropTypes.string,
  productId: PropTypes.string,
  fitNotes: PropTypes.string,
  stylistNotes: PropTypes.string,
  productDetails: PropTypes.string,
};
